import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationService} from '../services/authentication.service';
import * as swalFunctions from '../data/sweet-alert';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  swal = swalFunctions;

  constructor(private authenticationService: AuthenticationService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].includes(err.status)) {
        // auto logout if 401 or 403 response returned from api
        this.authenticationService.logout();
        return throwError(() => err); // En este caso se regresa el mismo error para usar códigos en el Login
      }

      // Procesamiento general de las excepciones
      const error = (err && err.error && err.error.message) || err.statusText;
      console.error(err);
      this.swal.TypeErrorDetails(err.message, err.error.trace);
      return throwError(() => error);
    }))
  }
}
